// What a tab shows while its first data arrives (Ruben, 2 Nov 2026: the tab
// switch looked broken when the footer rose into an empty page and was then
// pushed down). A quiet outline of a page, as tall as the screen, so nothing
// jumps when the real page replaces it; it fades in late, so a fast load never
// flashes it. Still under Reduce Motion.
import { S } from '../lib/strings';

export function Loading() {
  return (
    <section className="view on skel" aria-busy="true" aria-label={S.loading}>
      <div className="sk-ph"><i className="sk" style={{ width: 210, height: 28 }} /><i className="sk" style={{ width: 'min(420px, 70%)', height: 13 }} /></div>
      <div className="sk-row">
        {[0, 1, 2].map((i) => (
          <div key={i} className="card sk-card"><i className="sk" style={{ width: '38%', height: 10 }} /><i className="sk" style={{ width: '28%', height: 40 }} /><i className="sk" style={{ width: '72%', height: 12 }} /></div>
        ))}
      </div>
      <div className="card sk-big"><i className="sk" style={{ width: '24%', height: 14 }} />{[0, 1, 2, 3, 4].map((i) => <i key={i} className="sk" style={{ width: `${88 - i * 9}%`, height: 12 }} />)}</div>
    </section>
  );
}
